import { create } from 'zustand';

export const usePreviewTaskStore = create((set) => ({
  isPreviewTaskOpen: false,

  setPreviewTaskOpen: (isPreviewTaskOpen) => {
    set({ isPreviewTaskOpen });
  },
}));
